import script from "./RichEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./RichEditor.vue?vue&type=script&setup=true&lang=js"

import "./RichEditor.vue?vue&type=style&index=0&id=8811924c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8811924c"]])

export default __exports__